window.addEventListener('load', function () {
    'use strict';

    if (!document.querySelector('.rs-hero') && !document.querySelector('.rs-quote') && !document.querySelector('.rs-process')) return;

    // RS Hero — header fade-in
    var rsHeroHeader = document.querySelector('.rs-hero__header');
    if (rsHeroHeader) {
        gsap.fromTo(rsHeroHeader,
            { y: 30, opacity: 0 },
            {
                y: 0, opacity: 1,
                duration: 0.8,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: rsHeroHeader,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                }
            }
        );
    }

    // RS Hero — cards stagger
    gsap.utils.toArray('.rs-hero__card').forEach(function (card, i) {
        gsap.fromTo(card,
            { y: 40, opacity: 0 },
            {
                y: 0, opacity: 1,
                duration: 0.8,
                delay: i * 0.15,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: card,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                }
            }
        );
    });

    // RS Quote — content fade-in
    var rsQuoteContent = document.querySelector('.rs-quote__content');
    if (rsQuoteContent) {
        gsap.fromTo(rsQuoteContent,
            { y: 30, opacity: 0 },
            {
                y: 0, opacity: 1,
                duration: 1,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: rsQuoteContent,
                    start: 'top 80%',
                    toggleActions: 'play none none none'
                }
            }
        );
    }

    // RS Process — steps stagger
    gsap.utils.toArray('.rs-process__step').forEach(function (step, i) {
        gsap.fromTo(step,
            { y: 50, opacity: 0 },
            {
                y: 0, opacity: 1,
                duration: 0.8,
                delay: i * 0.15,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: step,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                }
            }
        );

        // Checklist items stagger within each step
        var checkItems = step.querySelectorAll('.rs-process__checklist-item');
        if (checkItems.length) {
            gsap.utils.toArray(checkItems).forEach(function (item, j) {
                gsap.fromTo(item,
                    { x: 20, opacity: 0 },
                    {
                        x: 0, opacity: 1,
                        duration: 0.5,
                        delay: j * 0.08,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 90%',
                            toggleActions: 'play none none none'
                        }
                    }
                );
            });
        }
    });
});
